import api from '@/api/fetch'
import type { Location } from '@/types'

export function getLocation() {
  return api.get<Location>('/location').then(res => res.data)
}
